'use strict';

const SlidingMenu = (function(){
    const cssTransform = typeof document.documentElement.style.transform === 'string' ? 'transform' : 'WebkitTransform';
    const cssTransitionDuration = typeof document.documentElement.style.transitionDuration === 'string' ? 'transitionDuration' : 'WebkitTransitionDuration';
    const on = (eventName, container, target, handler) => {
        container.addEventListener(eventName, e => {
            let el = e.target;

            while (el && el !== document) {
                if (el.matches(target)) {
                    handler.call(this, el, e);
                    return;
                }

                el = el.parentNode;
            }
        });
    }
    const animationFrame = (cb) => {
        window.requestAnimationFrame(() => window.requestAnimationFrame(() => cb()));
    }

    return function(el, options) {
        const config = {
            'title': '.title',
            'target': 0,
            'speed': 300
        };

        if (options)
            for (const k in config)
                if (options.hasOwnProperty(k))
                    config[k] = options[k];

        const container = typeof el === 'string' ? document.querySelector(el) : el;
        const title = container.querySelector(config['title']);

        let nav = [];
        let current = null;
        let prev = null;

        on('click', container , '[data-target]', (el, e) => {
            e.preventDefault();

            let target = el.dataset.target;
            let direction = 'left';
            let newMenu;

            if (target === '') {
                newMenu = nav.pop();
                direction = 'right';
            } else {
                nav.push(current);
                newMenu = container.querySelector(`[data-container="${target}"]`);
            }

            move(newMenu, direction);
        });

        const move = (newMenu, direction) => {
            let speed = direction === 'none' ? 0 : config['speed'];

            container.dataset['depth'] = nav.length.toString();

            if (current) {
                current.style[cssTransitionDuration] = `${speed}ms`;
                current.style[cssTransform] = `translate3d(${(direction === 'left' ? '-' : '')}100%, 0, 0)`;
            }

            if (direction === 'left')
                newMenu.scrollTop = 0;

            newMenu.style[cssTransitionDuration] = '0s';
            newMenu.style[cssTransform] = `translate3d(${(direction === 'left' ? '' : '-')}100%, 0, 0)`;

            animationFrame(() => {
                newMenu.style[cssTransitionDuration] = `${speed}ms`;
                newMenu.style[cssTransform] = `translate3d(0, 0, 0)`;
            })

            prev = current;
            current = newMenu;

            title.innerText = '';
            animationFrame(() => {
                title.innerText = current.dataset.title;
            });

            container.dispatchEvent(new CustomEvent('slidingmenu:move', {
                'bubbles': true,
                'detail': {
                    'current': current,
                    'prev': prev
                }
            }));
        }

        const slideTo = (target) => {
            let prev = null;
            let depth = 0;
            let index = target;

            nav = [];

            while (index > 0) {
                prev = container.querySelector(`[data-target="${index}"]`).closest('[data-container]');
                if (prev) {
                    nav.unshift(prev);
                    index = parseInt(prev.dataset.container);
                    depth++;
                } else {
                    index = 0;
                }
            }

            move(container.querySelector(`[data-container='${target}']`), 'none')
        }

        slideTo(parseInt(config['target']));

        return {
            'slideTo': slideTo,
            'current': () => current
        }
    };
})();
export default SlidingMenu;